import { mutationOptions } from '../../common/utils';
import { woocommerceAPIClient } from '../woocommerceAPIClient';
import { WOOCOMMERCE_QUERY_KEYS } from './keys';
import type { CreateWooCommerceOrderRequest } from './types';

export const WOOCOMMERCE_MUTATIONS = {
  createOrder: () =>
    mutationOptions({
      mutationFn: (payload: CreateWooCommerceOrderRequest) => woocommerceAPIClient.createOrder(payload),
      mutationKey: WOOCOMMERCE_QUERY_KEYS.createOrder(),
    }),
};
